export const CHANGE_FIELD_CODES = {
  contact: "A_0510",
  typeOfLoss: "A_0511",
  fraudOnAccount: "A_0512",
  transferToSecurity: "A_0513",
  bestWayToContact: "A_0514",
  shipReplacementTo: "A_0515",
  addressChangeToday: "A_0516",
  newAddressVerify: "A_0517",
  tempAddressVerify: "A_0518",
  replacementOption: "A_0519",
};

export const PHONE_VALUE_LENGTH = 10;
export const ADDRESS_LINE_MAX_LENGTH = 26;
export const CITY_MAX_LENGTH = 18;
export const ZIPCODE_LENGTH = 5;
export const ZIPCODE_PLUS_FOUR_LENGTH = 10;
export const FRAUD_CHARGES_MAX_LENGTH = 220;

export const addressRegex = /^[^!@#$%^&*()_+{}:>?"<~`\\/;|]*$/;
export const cityRegex = /^[A-z '-]*$/;
export const fraudChargesRegex = /^[A-z0-9 !@#$%^&[(){}?/'"\r\n=+.,;:<>`~|-]*$/;
export const additionalInfoRegex =
  /^[A-z0-9 !@#$%^&[(){}?/'"\r\n=+.,;:<>`~|-]*$/;

export const SPECIAL_FISERV_PHONE_NUMBERS = [
  "0000000000",
  "2222222222",
  "3333333333",
  "4444444444",
  "5555555555",
  "6666666666",
  "7777777777",
  "8888888888",
  "9990000000",
];
